import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule, NgbDateNativeAdapter  } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';

import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';

import { HomeModule } from './components/home.module';
import { UserModule } from './candidate/user.module';
import { VacanciesModule } from './vacancies/vacancies.module';
import { HttpClientModule } from '@angular/common/http';
import { BearerInterceptor } from './BearerInterceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthService } from './services';
import { WhatWeOfferComponent } from './components/what-we-offer.component';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    WhatWeOfferComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    RouterModule,
    HomeModule,
    UserModule,
    VacanciesModule,
    AppRoutingModule,
    
  ],
  providers: [
    NgbDateNativeAdapter,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BearerInterceptor,
      multi: true,
    },
    AuthService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
